'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const tokenReplace = require('dibs-token-replace');

function GridHeader({type, title}) {
    const headerCopy = type ? tokenReplace(title, {type}) : title;

    return <h2 className="pdp-grid-header">{headerCopy}</h2>;
}

GridHeader.propTypes = {
    title: PropTypes.string.isRequired,
    type: PropTypes.string
};

module.exports = GridHeader;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Grid/GridHeader.jsx